import { render, staticRenderFns } from "./VendedorDelete.vue?vue&type=template&id=31ce9671&"
import script from "./VendedorDelete.vue?vue&type=script&lang=js&"
export * from "./VendedorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports